import * as types from './actionTypes';
import anexosApi from '../api/anexosApi'

export function obterAnexosPorAtendimentoSuccess(anexos) {
    return { type: types.PESQUISAR_ANEXOS, anexos }
}

export function obterAnexosAtendimento(idAtendimento) {
    
    return function (dispatch) {
        return anexosApi.obterAnexosPorAtendimento(idAtendimento).then(anexos => {
            
            dispatch(obterAnexosPorAtendimentoSuccess(anexos));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function anexarSuccess(anexos) {
    return { type: types.ANEXAR, anexos }
}

export function anexar(idAtendimento, idHistorico, fileName, stream, visivel) {
    
    return function (dispatch) {
        return anexosApi.anexar(idAtendimento, idHistorico, fileName, stream, visivel).then(anexos => {
            
            dispatch(anexarSuccess(anexos));
        }).catch(error => {
            
            throw (error);
        });
    };
}





/** WEBPACK FOOTER **
 ** ./src/components/actions/anexosActions.js
 **/